import { useQuery } from '@tanstack/react-query';

import { getFrameUrls } from '../../api';
import { signedUrlStaleTime } from '../grid/useAssetUrls';

/** The query key every frame-URL reader shares, so a save can refresh them all. */
export const frameUrlsQueryKey = (assetId: string) =>
  ['asset-library', 'frame-urls', assetId] as const;

/**
 * Signed URLs for one carousel's frames, by frame id.
 *
 * One query for everything that shows a carousel's frames — the stage and the
 * frames editor beside it — so opening a carousel signs its frames once.
 * Fresh for as long as the signatures are, like the grid's `useAssetUrls`.
 */
export function useFrameUrls(assetId: string) {
  const query = useQuery({
    queryKey: frameUrlsQueryKey(assetId),
    queryFn: () => getFrameUrls(assetId),
    staleTime: (state) => signedUrlStaleTime(state.state.data?.expires_in_seconds),
    refetchOnWindowFocus: false,
  });
  const urlById = new Map((query.data?.urls ?? []).map((entry) => [entry.frame_id, entry.url]));
  return { ...query, urlById };
}
